module.exports = __webpack_public_path__ + "static/media/DOTUSA.cd3062ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/normes/DOTUSA.svg
// module id = 74
// module chunks = 0